/* eslint-disable camelcase */
import { type UseQueryResult, useQuery } from 'react-query';
import {
  IntegrationProviderService,
  type Wealthlane_HRIntegrationService_Dtos_IntegrationProviders_GetIntegrationProviderDto,
} from '@wealthlane/api-services/wealthlane-hr-integration-service';

const useGetIntegrationProvider = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  Wealthlane_HRIntegrationService_Dtos_IntegrationProviders_GetIntegrationProviderDto | undefined,
  unknown
> => {
  const IntegrationProvider = useQuery(['getIntegrationProvider'], async () => {
    return await handleRequest(
      IntegrationProviderService.getApiHrintegrationApiAppIntegrationProviderIntegrationProvider()
    );
  });

  return IntegrationProvider;
};

export default useGetIntegrationProvider;
